import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import webLogin from './weblogin';
import commonService from '@services/commonService';
var utils = {
  IPCountryCode: '',
  forceHttps: function forceHttps(url) {
    return url ? url.replace(/^https?\:/, '') : '';
  },
  getNavigatorLang: function getNavigatorLang() {
    return 'en';
  },
  getQueryData: function getQueryData(queryString) {
    queryString = queryString.replace(/^\?+/, "").replace(/&amp;/, "&");
    var querys = queryString.split("&"),
      i = querys.length,
      _URLParms = {};
    while (i--) {
      var item = querys[i].split("=");
      if (item[0]) {
        var value = item[1] || "";
        try {
          value = decodeURIComponent(value);
        } catch (e) {
          value = unescape(value);
        }
        _URLParms[decodeURIComponent(item[0])] = value;
      }
    }
    return _URLParms;
  },
  addQueryStringParameter: function addQueryStringParameter(uri, key, value) {
    if (!value) {
      return uri;
    }
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
      return uri + separator + key + "=" + value;
    }
  },
  GetQueryString: function GetQueryString(name) {
    if (name != undefined && name.trim().length) {
      name = name.trim();
    } else {
      name = undefined;
      return "";
    }
    var url = location.search || ''; //获取url中"?"符后的字串
    var theRequest = {};
    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      var strParams = str.split("&");
      for (var i = 0; i < strParams.length; i++) {
        theRequest[strParams[i].split("=")[0].trim()] = decodeURIComponent(strParams[i].split("=")[1]);
      }
    }
    if (name != undefined) {
      return theRequest[name] != undefined ? theRequest[name] : null;
    }
    return theRequest;
  },
  isMobile: function isMobile() {
    var UA = window.navigator.userAgent || '',
      IsAndroid = /Android|HTC/i.test(UA),
      IsIPhone = !IsAndroid && /iPod|iPhone/i.test(UA);
    return IsAndroid || IsIPhone;
  },
  directToPath: function directToPath(json) {
    var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var getSearchData = (window.location.search.match(/^\?+/) ? this.getQueryData(window.location.search) : {}) || '';
    var removeData = toString.call(json.remove) === "[object Array]" ? json.remove : [];
    for (var i = 0; i < removeData.length; i++) {
      delete getSearchData[removeData[i]];
    }
    if (getSearchData.short) {
      // getSearchData.short = '';
      delete getSearchData.short;
    }
    var searchObj = Object.assign({}, getSearchData, json.search || {});
    var searchStr = Object.keys(searchObj).map(function (key) {
      return encodeURIComponent(key) + "=" + encodeURIComponent(searchObj[key]);
    }).join("&");
    searchStr = Object.keys(searchObj).length === 0 ? searchStr : "?" + searchStr;
    var protocol = window.location.protocol || ''; // http:
    var origin = json.origin || protocol + '//' + window.location.host || ''; // 不带/
    var pathname = json.pathname || window.location.pathname || ''; // 需要带/
    if (!isInit) {
      //初始化url不上报
      this.KEWLSensorTrack({
        lmweb_clickText: '跳转',
        lmweb_tabName: pathname
      });
    }
    return origin + pathname + searchStr;
  },
  directTo: function directTo(json) {
    window.location.href = this.directToPath(json);
  },
  browser: {
    versions: function () {
      var u = navigator.userAgent;
      return {
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1,
        iPad: u.indexOf('iPad') > -1
      };
    }()
  },
  detctWebp: function detctWebp() {
    var elem = document.createElement('canvas') || {};
    if (!!(elem.getContext && elem.getContext('2d'))) {
      // was able or not to get WebP representation
      return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    } else {
      // very old browser like IE 8, canvas not supported
      return false;
    }
  },
  getDoMain: function getDoMain() {
    var param = this.getQueryData(window.location.search) || {};
    var domain = '';
    if (param.host == 'test') {
      domain = '//featuremix-qa.live.liveme.com';
    } else {
      if (('' + (navigator.language || navigator.browserLanguage)).toLowerCase().split('-')[0] == 'ar') {
        domain = '//live.liveme.com';
      } else {
        domain = '//live.liveme.com';
      }
    }
    return domain;
  },
  uuid: function uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
  },
  isSpa: function isSpa() {
    if (window.SSR) {
      return false;
    } else {
      return true;
    }
  },
  getI18nLocale: function getI18nLocale() {
    if (window.$i18n) {
      return window.$i18n.urlLang ? window.$i18n.urlLang : 'en';
    } else {
      return window.store ? window.store.state.locale : "en";
    }
  },
  getI18nCountryCode: function getI18nCountryCode(countryCode) {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var user, cc;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // if(window.$i18n){
            //     return (await window.$i18n.countryCode ? window.$i18n.countryCode : "us").toLowerCase();
            // }else{
            // if (countryCode) {
            //     return countryCode.toLowerCase();
            // } else {
            user = webLogin.getUserInfo();
            if (!user) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", user.country ? user.country.toLowerCase() : 'us');
          case 5:
            cc = localStorage.getItem("countryCode");
            if (!cc) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", cc.toLowerCase());
          case 10:
            _context.next = 12;
            return _this.getCountryCodeByIp();
          case 12:
            return _context.abrupt("return", _context.sent.toLowerCase());
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  getCountryCodeByIp: function getCountryCodeByIp() {
    var _arguments = arguments,
      _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var isDefault, data, countryCode;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            isDefault = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;
            _context2.prev = 1;
            console.log(_this2.IPCountryCode, '--this.IPCountryCode--');
            if (!_this2.IPCountryCode) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", _this2.IPCountryCode);
          case 5:
            _context2.next = 7;
            return commonService.createApi().getCountryCodeByIp();
          case 7:
            data = _context2.sent;
            if (!data) {
              _context2.next = 13;
              break;
            }
            countryCode = data.countryCode;
            localStorage.setItem("countryCode", countryCode);
            _this2.IPCountryCode = countryCode;
            return _context2.abrupt("return", countryCode);
          case 13:
            _context2.next = 19;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](1);
            console.log('--');
            return _context2.abrupt("return", isDefault ? "US" : "");
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 15]]);
    }))();
  },
  nFormatter: function nFormatter(num, digits) {
    var si = [{
      value: 1,
      symbol: ''
    }, {
      value: 1E3,
      symbol: 'K'
    }, {
      value: 1E6,
      symbol: 'M'
    }, {
      value: 1E9,
      symbol: 'G'
    }, {
      value: 1E12,
      symbol: 'T'
    }, {
      value: 1E15,
      symbol: 'P'
    }, {
      value: 1E18,
      symbol: 'E'
    }];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }
    return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
  },
  getImInfo: function getImInfo() {
    if (window.baseAxios) {
      return window.baseAxios.imUrls ? window.baseAxios.imUrls : [];
    } else {
      /**
       * spa保底的im
       */
      return [{
        host: 'webim1.fusionv.com',
        port: '80'
      }, {
        host: 'webim2.fusionv.com',
        port: '80'
      }];
    }
  },
  isPC: function isPC() {
    return !/iPad|iPod|iPhone/i.test(window.navigator.userAgent) && !/Android|HTC/i.test(window.navigator.userAgent);
  },
  getAge: function getAge(birthday) {
    if (!birthday) {
      return 0;
    }
    return Math.abs(new Date(Date.now() - Date.parse(birthday.replace(/[\-\.]/g, '/'))).getUTCFullYear() - 1970);
  },
  loadingFunc: function loadingFunc(args) {
    function Cobj(args) {
      var _this3 = this;
      if (document.getElementById('lmloading')) {
        document.getElementById('lmloading').remove();
      }
      this.size = args ? args.size || 'middle' : 'middle';
      this.zindex = args ? args.zindex || 999999999 : 999999999;
      this.dom = document.createElement('div');
      this.dom.id = 'lmloading';
      this.dom.className = 'lm-loading';
      this.dom.innerHTML = "<div class=\"slideload ".concat(this.size, "\" style=\"z-index: ").concat(this.zindex, ";overflow: hidden; position: fixed;\"><div class=\"slin\"><div class=\"spinner\"></div></div></div>");
      document.body.appendChild(this.dom);
      this.hide = function () {
        if (document.getElementById('lmloading')) {
          document.getElementById('lmloading').remove();
        }
        delete this.size;
        delete this.zindex;
        delete this.dom;
        delete this.hide;
      };
      if (args && args.time) {
        setTimeout(function () {
          _this3.hide();
        }, args.time);
      }
    }
    return new Cobj(args);
  },
  touchmoveClose: function touchmoveClose() {
    document.body.style.overflow = 'hidden'; // 禁止页面滑动
  },
  touchmoveBegin: function touchmoveBegin() {
    document.body.style.overflow = ''; // 出现滚动条
  },
  touchmove: function touchmove() {
    function Cobj() {
      var _this4 = this;
      this.handler = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = 'hidden'; // 禁止页面滑动
      document.addEventListener('touchmove', this.handler, {
        passive: false
      });
      this.destroy = function () {
        document.body.style.overflow = ''; // 出现滚动条
        document.removeEventListener('touchmove', this.handler, {
          passive: false
        });
      };
      setTimeout(function () {
        _this4.destroy();
      }, 2000);
    }
    return new Cobj();
  },
  /**
  * cookie中存值
  */
  setCookie: function setCookie(name, value) {
    var day = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var Days = day;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
  },
  /**
  * cookie中取值
  */
  getCookie: function getCookie(name) {
    var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"); //匹配字段
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  /**
  * 清除指定cookie值
  */
  delCookie: function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = setCookie(name);
    if (cval && cval != null) {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },
  downApp: function downApp() {
    var UA = window.navigator.userAgent;
    var IsAndroid = /Android|HTC/i.test(UA);
    var IsIPad = !IsAndroid && /iPad/i.test(UA);
    var IsIPhone = !IsAndroid && /iPod|iPhone/i.test(UA);
    var IsIOS = IsIPhone || IsIPad;
    if (IsAndroid) {
      this.KEWLSensorTrack({
        lmweb_clickText: '直播间下载app',
        lmweb_tabName: 'Android'
      });
      window.location.href = this.getDownloadURL("", this.getBrand(UA)).android;
    } else if (IsIOS) {
      this.KEWLSensorTrack({
        lmweb_clickText: '直播间下载app',
        lmweb_tabName: 'IOS'
      });
      window.location.href = 'https://liveme.onelink.me/1702380906/inappshare';
    }
  },
  defaultUserPortrait: function defaultUserPortrait(user) {
    // 0: female; 1: male; -1: unknown;
    if (user) {
      switch (user.sex) {
        case '0':
          return 'http://esx.esxscloud.com/small/liveme/1d32d2352d2e9adc5423d6ccea534091_icon.jpeg';
        case '1':
          return 'http://esx.esxscloud.com/small/liveme/4d0fa3f62cc4fad17f9d0bdc244b3225_icon.jpeg';
        default:
          break;
      }
    }
    return 'http://esx.esxscloud.com/small/liveme/4d0fa3f62cc4fad17f9d0bdc244b3225_icon.jpeg';
  },
  deepCompare: function deepCompare(xx, yy) {
    var i;
    var l;
    var leftChain;
    var rightChain;
    function compare2Objects(x, y) {
      var p = '';

      // remember that NaN === NaN returns false
      // and isNaN(undefined) returns true
      if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
        return true;
      }

      // Compare primitives and functions.     
      // Check if both arguments link to the same object.
      // Especially useful on the step where we compare prototypes
      if (x === y) {
        return true;
      }

      // Works in case when functions are created in constructor.
      // Comparing dates is a common scenario. Another built-ins?
      // We can even handle functions passed across iframes
      if (typeof x === 'function' && typeof y === 'function' || x instanceof Date && y instanceof Date || x instanceof RegExp && y instanceof RegExp || x instanceof String && y instanceof String || x instanceof Number && y instanceof Number) {
        return x.toString() === y.toString();
      }

      // At last checking prototypes as good as we can
      if (!(x instanceof Object && y instanceof Object)) {
        return false;
      }
      if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
        return false;
      }
      if (x.constructor !== y.constructor) {
        return false;
      }
      if (x.prototype !== y.prototype) {
        return false;
      }

      // Check for infinitive linking loops
      if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
        return false;
      }

      // Quick checking of one object being a subset of another.
      // todo: cache the structure of arguments[0] for performance
      for (p in y) {
        if (y.hasOwnProperty(p)) {
          if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
          } else if (_typeof(y[p]) !== _typeof(x[p])) {
            return false;
          }
        } else {
          return false;
        }
      }
      for (p in x) {
        if (y.hasOwnProperty(p)) {
          if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
            return false;
          } else if (_typeof(y[p]) !== _typeof(x[p])) {
            return false;
          }
          switch (_typeof(x[p])) {
            case 'object':
            case 'function':
              leftChain.push(x);
              rightChain.push(y);
              if (!compare2Objects(x[p], y[p])) {
                return false;
              }
              leftChain.pop();
              rightChain.pop();
              break;
            default:
              if (x[p] !== y[p]) {
                return false;
              }
              break;
          }
        } else {
          return false;
        }
      }
      return true;
    }
    if (arguments.length < 1) {
      return true; // Die silently? Don't know how to handle such case, please help...
      // throw "Need two or more arguments to compare";
    }
    for (i = 1, l = arguments.length; i < l; i++) {
      leftChain = []; // Todo: this can be cached
      rightChain = [];
      if (!compare2Objects(arguments[0], arguments[i])) {
        return false;
      }
    }
    return true;
  },
  promisify: function promisify(callback, context) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return new Promise(function (resolve, reject) {
      callback.call.apply(callback, [context].concat(args, [resolve, reject]));
    });
  },
  getQueryString: function getQueryString(name) {
    var reg = new RegExp("(^|&)".concat(name, "=([^&]*)(&|$)"));
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return r[2];
    }
    return '';
  },
  /**
  * 判断两个时间是否为同一天。
  * @param a - Date.now();
  * @param b - Date.now();
  */
  isSameDay: function isSameDay(a, b) {
    return Math.floor(a / 86400000) === Math.floor(b / 86400000);
  },
  getBrand: function getBrand(UA) {
    var isHuawei = /huawei|honor/i.test(UA),
      isIOS = /iPad|iPod|iPhone/i.test(UA),
      isSamsung = /sm-/i.test(UA);
    if (isSamsung) {
      return "samsung";
    } else if (isHuawei) {
      return "huawei";
    } else if (isIOS) {
      return "apple";
    } else {
      return "android";
    }
  },
  getDownloadURL: function getDownloadURL(uid, device) {
    var huaweiLink = "https://appgallery1.huawei.com/#/app/C100418605";
    var androidLink = "https:/app/download/apk/liveme.apk";
    var gpLink = "https://play.google.com/store/apps/details?id=com.europe.live";
    // const mhuaweiLink = `https://appgallery.cloud.huawei.com/uowap/index.html#/detailApp/C100418605`;
    if (this.isMobile()) {
      if (device === 'samsung') {
        androidLink = 'https://samsunglivme.onelink.me/3a5M/afb97eea';
      }
      return {
        "applestore": "https://llivemeios.onelink.me/pzKc/iosofficialnewwebsite",
        //"https://go.onelink.me/app/iosofficialwebsite",
        "android": androidLink,
        "huaweistore": huaweiLink,
        "googleplay": gpLink
      };
    } else {
      return {
        "applestore": "https://llivemeios.onelink.me/pzKc/iosofficialnewwebsite",
        //"https://go.onelink.me/app/iosofficialwebsite",
        "android": "https:/app/download/apk/liveme.apk",
        "huaweistore": huaweiLink,
        "googleplay": gpLink
      };
    }
  },
  dowAppStore: function dowAppStore() {
    //window.location.href = "https://app.appsflyer.com/id1089836344?pid=CMS&c=H5_entry_" + channel;
    //window.location.href = "https://app.appsflyer.com/id1089836344?pid=websitemiddle"; // 0912修改
    window.location.href = 'https://liveme.onelink.me/1702380906/inappshare';
  },
  tryOpen: function tryOpen(url) {
    if (!url && url !== '') {
      return;
    }
    var frame = document.createElement("iframe");
    frame.style.cssText = "width:1px;height:1px;position:fixed;top:0;left:0;";
    frame.src = url;
    document.body.appendChild(frame);
    setTimeout(function () {
      document.body.removeChild(frame);
    }, 10);
  },
  OpenMarket: function OpenMarket(obj) {
    var self = this;
    if (obj) {
      setTimeout(function () {
        if (!!obj.market) {
          self.tryOpen(obj.market);
        }
        var startTime = new Date().valueOf();
        setTimeout(function () {
          var endTime = new Date().valueOf();
          if (1550 > endTime - startTime && typeof obj.fail == 'function') {
            obj.fail();
          } else if (typeof obj.success == 'function') {
            obj.success();
          }
        }, 1500);
      }, 100);
    }
  },
  openGP: function openGP() {
    var gpUrl = "https://liveme.onelink.me/1702380906/inappshare";
    var marketUrl = 'market://details?id=' + atob("Y29tLmNtY20ubGl2ZQ=="),
      gaDesc = '';
    //暂时屏蔽
    //gpUrl += '&referrer=utm_source%3D';
    marketUrl += '&referrer=utm_source%3D';
    if (typeof cm_web_app != 'undefined' && cm_web_app.hasOwnProperty('go2Google')) {
      cm_web_app.go2Google(gpUrl);
    } else if (typeof cm_web_app != 'undefined' && cm_web_app.hasOwnProperty('openMarket')) {
      cm_web_app.openMarket(gpUrl);
    } else if (typeof android != 'undefined' && android.hasOwnProperty('openMarket')) {
      android.openMarket(gpUrl);
    } else {
      this.OpenMarket({
        market: marketUrl,
        fail: function fail() {
          window.location.href = gpUrl;
        }
      });
    }
  },
  handeError: function handeError() {
    try {
      var defaultOnerror = window.onerror;
      // eslint-disable-next-line no-unused-vars
      window.onerror = function (msg, url, line, col, error) {
        var string = msg.toLowerCase();
        var substring = 'script error';
        var suvsting1 = 'legal invocation';
        if (string.indexOf(substring) > -1 || string.indexOf(suvsting1) > -1) {
          console.log(msg);
        } else {
          // eslint-disable-next-line prefer-rest-params
          defaultOnerror && defaultOnerror.apply && defaultOnerror.apply(window, arguments);
        }
      };
    } catch (e) {
      console.log(e);
    }
  },
  gotoDownload: function gotoDownload() {
    // 0912 修改
    var self = this;
    if (this.browser.versions.iPhone || this.browser.versions.iPad) {
      setTimeout(function () {
        self.dowAppStore();
      }, 2000);
    } else {
      setTimeout(function () {
        self.openGP(); //android 会跳中转页下载不兼容
      }, 500);
    }
  },
  getValue: function getValue(object, path, defaultValue) {
    return path.replace(/\[/g, '.').replace(/\]/g, '').split('.').reduce(function (o, k) {
      return (o || {})[k];
    }, object) || defaultValue;
  },
  /**
   * 神策 上报
   * lmweb_clickText:用户的点击操作对应的文案 如果是直播列表上报vid,用户头像上报UID
   * 重点：趋势，充值，提现，登录，注册，获取验证码，分类tab,follow,送礼，发送消息，直播列表点击"
   * tabName:分类
   * giftId:礼物ID
   * giftId:礼物价格
   */
  KEWLSensorTrack: function KEWLSensorTrack(params) {
    var defaultParams = {
      lmweb_clickText: '',
      lmweb_tabName: '',
      lmweb_giftId: '',
      lmweb_giftPriceLong: 0,
      lmweb_LiveUid: '',
      //直播间Uid
      lmweb_LiveVid: '' //直播间Vid
    };
    var KEWLSensorParams = Object.assign(defaultParams, params);
    if (typeof KEWLSensor !== 'undefined') {
      window.KEWLSensor.register('kewlweb_Imsite', defaultParams);
      window.KEWLSensor.track(KEWLSensorParams);
    }
  },
  // 防抖 注意 接收的是一个 function 而不是 箭头函数 [ this 指向 修正 需要 ]
  debounce: function debounce(callback, delay) {
    var timer = null;
    return function () {
      var _this5 = this;
      if (timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        if (callback) {
          // eslint-disable-next-line no-invalid-this
          callback.apply(_this5);
        }
      }, delay);
    };
  },
  // 是否在 可是区域内
  isElementInViewport: function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    var width_st = rect.width / 2,
      height_st = rect.height / 2;
    var innerHeight = window.innerHeight,
      innerWidth = window.innerWidth;
    if (rect.top <= 0 && rect.height > innerHeight || rect.left <= 0 && rect.width > innerWidth) {
      return rect.left * rect.right <= 0 || rect.top * rect.bottom <= 0;
    }
    return rect.height > 0 && rect.width > 0 && (rect.top >= 0 && rect.top <= innerHeight - height_st || rect.bottom >= height_st && rect.bottom <= innerHeight) && (rect.left >= 0 && rect.left <= innerWidth - width_st || rect.right >= width_st && rect.right <= innerWidth);
  },
  /**
   * @desc 大数据上报
   *  https://ldc.liveme.com/v1
   *  测试地址：http://qa.ldc.ksmobile.net/v1
   * @param {*} params 
   * {
   * act:1,   // 文档https://liveme.feishu.cn/docs/doccnh4JcD86Q1Q1jbxwBiSmoDh#
   *           // 文档修订版 ： https://liveme.feishu.cn/docs/doccnRezE68yHbfRgEDZDTP5PIg#
   * c:'video info string',
   * d: 'video info string'
   * }
   */
  ldcTrack: function ldcTrack(params, isArray) {
    if (this.isMobile()) {
      return;
    }
    var defaultParams = {
      et: Math.round(new Date().getTime() / 1000),
      v: 1
    };
    var ldcParams = {};
    if (!isArray) {
      ldcParams = Object.assign(defaultParams, params);
    }
    var resultParams = [];
    if (isArray) {
      params.forEach(function (ele) {
        resultParams.push(JSON.stringify(Object.assign(defaultParams, ele)));
      });
    } else {
      resultParams.push(JSON.stringify(ldcParams));
    }
    // const reportUrl = 'http://qa.ldc.ksmobile.net/v1'  // 测试环境
    var reportUrl = 'https://ldc.liveme.com/v1'; // online环境
    // let postData = '[{"et":"1630402287","msg":1,"act":4,"v":"1"}]';

    var postData = '[' + resultParams.join(',') + ']';
    // console.info(postData)
    if (window.KEWLHttp) {
      window.KEWLHttp({
        method: 'POST',
        url: reportUrl,
        data: postData,
        header: {
          'Content-type': 'application/json'
        },
        transformRequest: [function (data) {
          return data.split('&')[0];
        }]
      });
    }
  },
  isJMT: function isJMT(countryCode) {
    if ((countryCode.toLowerCase() === 'tw' || this.getI18nLocale() === 'tw') && this.getQueryString('source') === 'jmt') {
      return true;
    } else {
      return false;
    }
  },
  isTW: function isTW(countryCode) {
    if (countryCode.toLowerCase() === 'tw' || this.getI18nLocale() === 'tw') {
      return true;
    } else {
      return false;
    }
  }
};
export default utils;